import React from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'

const GOOGLE_DRIVE_HOW_IT_WORKS_BASE = [
  'Link a Google Drive folder to any client in Zocks',
  'Save generated PDFs - meeting summaries, meeting prep, forms - straight to Google Drive',
  'Keep client documents organized across both platforms',
  'Browse and upload files from My Drive and your shared drives directly in Zocks',
]

const GOOGLE_DRIVE_HOW_IT_WORKS_ULTIMATE = [
  'Pull documents from Google Drive into Zocks for processing - no manual uploads needed',
  'Save document summaries to Google Drive',
  'Work from your existing Google Drive library without leaving the platform',
]

export const GoogleDriveHowItWorks: React.FC = () => {
  const { hasQuota } = useZocksQuota()
  const documentIntelligenceEnabled = hasQuota('ai.documentSummaryAgent.value')
  const lines = documentIntelligenceEnabled ? [...GOOGLE_DRIVE_HOW_IT_WORKS_BASE, ...GOOGLE_DRIVE_HOW_IT_WORKS_ULTIMATE] : GOOGLE_DRIVE_HOW_IT_WORKS_BASE

  return (
    <div>
      <ul>
        {lines.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
